<template>
    <Mainpage>
      <div class="main-section__wrapper">
        <h2 class="title2 text-center mt12" :style="{ fontSize: '20px' }">
          Check your Gift Card Balance
        </h2>
        <p class="body text-center mt8">
          Please enter your Gift Card details to check your balance
        </p>

        <form @submit.prevent="onSubmit" class="form-wrapper">
          <div class="form-group">
            <label class="title6">Gift and details</label>

            <div class="xs12">
              <label class="title7"
                >Gift Card Number <span :style="{ color: '#FF0000' }">*</span>
              </label>
              <input
                v-model="cardNumbers"
                class="form-control"
                type="text"
                pattern=".*\S+.*"
                required
              />
              <div v-if="!isChecking && !isSuccess" class="error-message">
                {{ errorMessage }}
              </div>
            </div>
            <div class="xs12">
              <label class="title7"
                >PIN <span :style="{ color: '#FF0000' }">*</span></label
              >
              <input v-model="pin" class="form-control" type="password" />
            </div>
          </div>

          <div v-if="!isChecking && isSuccess" class="text-center mt6">
            <h4 class="title3">Gift Card Balance</h4>
            <p class="title4 money-font">
              ${{ apiResult.giftcard.balance }}.00
            </p>
          </div>

          <div class="text-center xs12 mt2">
            <button
              class="btn btn-primary btn-block mt2 xs12"
              :style="{ backgroundColor: '#3862eb' }"
            >
              {{ isChecking ? "Checking..." : "Check Balance" }}
            </button>
          </div>
        </form>
        <GiftcardFooter class="mt-5"/>
      </div>
    </Mainpage>
</template>

<script lang="ts">
import GiftcardFooter from "./GiftCardFooter.vue";
import Mainpage from "./Mainpage.vue";
import { mapMutations } from "vuex";

export default {
  components: { GiftcardFooter, Mainpage },
  data(){
    return {
      form: { cardNumbers: "", pin: "" },
      isChecking: false,
      isSuccess: false,
      errorMessage: ""
    }
  },
  mounted(){
    this.setStoreLoaded();
  },
  methods: {
    ...mapMutations(["setStoreLoaded"]),
    onSubmit(){
    }
  }
};
</script>

<style scoped>
.gift-card-button {
  background-color: #ffffff;
  font-family: Open Sans;
  margin-top: 1%;
  color: black;
  position: absolute;
  right: 13.8%;
}
.form-wrapper {
  max-width: 300px;
  margin: 0 auto;
}

.logo-section {
  border-bottom: 1px solid rgb(128, 128, 128, 0.3);
  width: 100%;
  height: 8%;
}

.error-message {
  color: red;
}
@media only screen and (max-width: 900px) {
  .gift-card-button {
    right: 0;
    color: #55a7ff;
    z-index: 2;
    border: none;
  }

  .main-section__wrapper {
    margin-top: 4rem;
    padding: 1rem 1rem;
  }
  .btn-block {
    width: 100%;
  }

  .main-section__wrapper {
    margin-top: 0;
  }
  .money-font {
    font-weight: 600;
    font-size: 30px;
  }
}
</style>
